import { MappedClass, MappedProperty } from '@h5s/util-object';
import { DeviceType } from './device-type';
import { Manufacturer } from './manufacturer';
import { PaperSize } from './paper-size';

@MappedClass()
export class CashRegisterType {
  @MappedProperty()
  type: DeviceType;

  @MappedProperty()
  paperSize: PaperSize;

  @MappedProperty()
  manufacturer: Manufacturer;
}
